

interface ItemProps {
  "REFERENCIA": string
  "PERGUNTA DO TECNICO": string
  "PERGUNTA DE EXIBIÇÃO": string
  "MÓDULO": string
  "SUB MODULO": string
  "CATEGORIA SUBMODULO": string
}

export const items: ItemProps[] = [
  // ── 1 CABINA INTERNA ─────────────────────────────────────────────────────
  {
    "REFERENCIA": "1.1",
    "PERGUNTA DO TECNICO": "Painel de operação",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA INTERNA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "1.2",
    "PERGUNTA DO TECNICO": "Botões, indicadores e display do painel de operação",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA INTERNA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "1.3",
    "PERGUNTA DO TECNICO": "Alarme e intercomunicador",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA INTERNA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "1.4",
    "PERGUNTA DO TECNICO": "Placa Capac., Avisos, Lic. Municipal e placa ABNT",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA INTERNA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "1.5",
    "PERGUNTA DO TECNICO": "Iluminação principal e de emergência da cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA INTERNA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "1.6",
    "PERGUNTA DO TECNICO": "Régua de segurança",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA INTERNA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },

  // ── 2 PAVIMENTO ───────────────────────────────────────────────────────────
  {
    "REFERENCIA": "2.1",
    "PERGUNTA DO TECNICO": "Placas de sinalização (municip., Estad. e federal)",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "PAVIMENTO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "2.2",
    "PERGUNTA DO TECNICO": "Nivelamento de Pavimento",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "PAVIMENTO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },

  // ── 3 MAQUINÁRIO & COMANDO ────────────────────────────────────────────────
  {
    "REFERENCIA": "3.1",
    "PERGUNTA DO TECNICO": "Porta de inspeção e alçapão",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.2",
    "PERGUNTA DO TECNICO": "Resgate Manual pelo Quadro de Comando",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.3",
    "PERGUNTA DO TECNICO": "Iluminação e luz de emergência da casa de máquina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.4",
    "PERGUNTA DO TECNICO": "Porta de acesso e extintor da casa de máquina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.5",
    "PERGUNTA DO TECNICO": "Escada e guarda-corpo do patamar superior",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.6",
    "PERGUNTA DO TECNICO": "Isolamento e aterramento dos terminais do motor",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.7",
    "PERGUNTA DO TECNICO": "Placa de suspensão da casa da máquina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.8",
    "PERGUNTA DO TECNICO": "Validade da graxa do conjunto de freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.9",
    "PERGUNTA DO TECNICO": "Embolo do freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.10",
    "PERGUNTA DO TECNICO": "Braços das sapatas lonas e articulações do freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.11",
    "PERGUNTA DO TECNICO": "Molas do freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.12",
    "PERGUNTA DO TECNICO": "Contato BK e CPF do freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.13",
    "PERGUNTA DO TECNICO": "Teste de deslize do freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.14",
    "PERGUNTA DO TECNICO": "Alavanca, volante e sistema de abertura do freio",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.15",
    "PERGUNTA DO TECNICO": "Protetor da polia de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.16",
    "PERGUNTA DO TECNICO": "Canais da polia de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.17",
    "PERGUNTA DO TECNICO": "Cabos de tração e cinta de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.18",
    "PERGUNTA DO TECNICO": "Retentores, juntas e visores da máquina de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.19",
    "PERGUNTA DO TECNICO": "Validade do óleo da máquina de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.20",
    "PERGUNTA DO TECNICO": "Coroa da máquina de atração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.21",
    "PERGUNTA DO TECNICO": "Rolamentos da máquina de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.22",
    "PERGUNTA DO TECNICO": "Borracha de acoplamento do redutor",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.23",
    "PERGUNTA DO TECNICO": "Ventilação forçada da máquina de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.24",
    "PERGUNTA DO TECNICO": "Comutador e escovas do motor",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.25",
    "PERGUNTA DO TECNICO": "Eixos da máquina de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.26",
    "PERGUNTA DO TECNICO": "Máquina de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.27",
    "PERGUNTA DO TECNICO": "Limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.28",
    "PERGUNTA DO TECNICO": "Proteção da polia do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.29",
    "PERGUNTA DO TECNICO": "Canal da polia do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.30",
    "PERGUNTA DO TECNICO": "Lacre de segurança do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.31",
    "PERGUNTA DO TECNICO": "Cabo de aço do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.32",
    "PERGUNTA DO TECNICO": "Teste do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.33",
    "PERGUNTA DO TECNICO": "Contato elétrico do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.34",
    "PERGUNTA DO TECNICO": "Aterramento do limitador de velocidade",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.35",
    "PERGUNTA DO TECNICO": "Fusíveis, disjuntores e IDR do quadro de comando",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.36",
    "PERGUNTA DO TECNICO": "Fusíveis, disjuntores, IDR e DPS do quadro de força",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.37",
    "PERGUNTA DO TECNICO": "Aterramento do quadro de comando de força",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.38",
    "PERGUNTA DO TECNICO": "Aterramento do autótrafo e do conjunto de resistores",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.39",
    "PERGUNTA DO TECNICO": "Teste do nobreak e do resgate automático",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.40",
    "PERGUNTA DO TECNICO": "Limites de parada e fim de curso de subida",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.41",
    "PERGUNTA DO TECNICO": "Limite de parada e fim de curso de descida",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "3.42",
    "PERGUNTA DO TECNICO": "Teste do aparelho de segurança",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "MAQUINÁRIO & COMANDO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },

  // ── 4 CABINA EM CIMA ──────────────────────────────────────────────────────
  {
    "REFERENCIA": "4.1",
    "PERGUNTA DO TECNICO": "Cabo e correia do operador de porta",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.2",
    "PERGUNTA DO TECNICO": "Contato elétrico porta de Cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.3",
    "PERGUNTA DO TECNICO": "Aterramento do topo da cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.4",
    "PERGUNTA DO TECNICO": "Comando sobe desce do topo da cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.5",
    "PERGUNTA DO TECNICO": "Botão Stop do topo da cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.6",
    "PERGUNTA DO TECNICO": "Balaustrada",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.7",
    "PERGUNTA DO TECNICO": "Placa de suspensão do Topo cabina e contrapeso",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.8",
    "PERGUNTA DO TECNICO": "Última altura - medida HA, HB e HC",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.9",
    "PERGUNTA DO TECNICO": "Polia de desvio, prot. de polia e sist. anti-pulo",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.10",
    "PERGUNTA DO TECNICO": "Aparelho de segurança superior",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "4.11",
    "PERGUNTA DO TECNICO": "Corrediças do topo da cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CABINA EM CIMA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },

  // ── 5 CAIXA DE CORRIDA ────────────────────────────────────────────────────
  {
    "REFERENCIA": "5.1",
    "PERGUNTA DO TECNICO": "Contato elétrico das portas de pavimento",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.2",
    "PERGUNTA DO TECNICO": "Aterramento das portas de pavimento",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.3",
    "PERGUNTA DO TECNICO": "Cabo de manobra",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.4",
    "PERGUNTA DO TECNICO": "Integridade, balanceamento e contato elétrico das cintas de tração",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.5",
    "PERGUNTA DO TECNICO": "Diâmetro, integridade e tensionamento dos cabos de aço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.6",
    "PERGUNTA DO TECNICO": "Tirantes dos cabos de aço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.7",
    "PERGUNTA DO TECNICO": "Posicionamento dos clipes de cabo de aço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.8",
    "PERGUNTA DO TECNICO": "Iluminação da caixa de corrida",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "5.9",
    "PERGUNTA DO TECNICO": "Contrapeso, varões e fixação",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "CAIXA DE CORRIDA",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },

  // ── 6 POÇO ────────────────────────────────────────────────────────────────
  {
    "REFERENCIA": "6.1",
    "PERGUNTA DO TECNICO": "Escada de acesso ao poço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.2",
    "PERGUNTA DO TECNICO": "Botão top do poço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.3",
    "PERGUNTA DO TECNICO": "Cornija da Cabina (aba da soleira)",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.4",
    "PERGUNTA DO TECNICO": "Aterramento do poço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.5",
    "PERGUNTA DO TECNICO": "Sistema de amortecimento",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.6",
    "PERGUNTA DO TECNICO": "Aparelho de segurança",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.7",
    "PERGUNTA DO TECNICO": "Contato GRS do aparelho de segurança",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.8",
    "PERGUNTA DO TECNICO": "Cabo e corrente de compensação",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.9",
    "PERGUNTA DO TECNICO": "Polia de compensação",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.10",
    "PERGUNTA DO TECNICO": "Contato elétrico da polia de compensação",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.11",
    "PERGUNTA DO TECNICO": "Contato elétrico da polia tensora",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.12",
    "PERGUNTA DO TECNICO": "Polia tensora",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.13",
    "PERGUNTA DO TECNICO": "Medir deslize de cabina (LCAB)",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.14",
    "PERGUNTA DO TECNICO": "Medir espicho do cabo (LCP)",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.15",
    "PERGUNTA DO TECNICO": "Poço",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
  {
    "REFERENCIA": "6.16",
    "PERGUNTA DO TECNICO": "Corrediças inferiores da cabina",
    "PERGUNTA DE EXIBIÇÃO": "",
    "MÓDULO": "POÇO",
    "SUB MODULO": "",
    "CATEGORIA SUBMODULO": ""
  },
]

export const modulos = {} as { [key: string]: string[] }
const modules = [...new Set(items.map(item => item.MÓDULO))]
modules.forEach(mod => modulos[mod] = [])
items.forEach(item => modulos[item.MÓDULO].push(item.REFERENCIA));

export const itemMap = {} as { [key: string]: ItemProps }
items.forEach(item => itemMap[item.REFERENCIA] = item)
